import { Link } from "react-router-dom";
import { siteMeta, siteValues } from "@/mocks/site";

export default function IntroSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="w-full aspect-[9/8] rounded-3xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20glowing%20speech%20bubble%20shapes%20floating%20above%20a%20soft%20cream%20desk%20with%20a%20smartphone%2C%20cozy%20ambient%20lighting%2C%20minimal%20composition%2C%20amber%20and%20coral%20palette&width=900&height=800&seq=bl91-intro-comments&orientation=squarish"
              alt="评论区观点聚合的抽象插画"
              title="爆料91 评论区观点聚合"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 left-5 md:left-8 rounded-2xl bg-background-50 border border-background-200 px-5 py-4 max-w-[240px]">
            <p className="text-2xl font-black text-primary-600 font-heading">18.6万+</p>
            <p className="mt-1 text-xs text-foreground-600">条评论区观点已被整理归档</p>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-bold">
            <i className="ri-compass-3-line"></i>
            我们怎么看待吃瓜
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-black text-foreground-950 font-heading leading-snug">
            我们不打探隐私，只把讨论讲清楚
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            {siteMeta.intro}
          </p>

          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {siteValues.map((value) => (
              <li key={value.title} className="rounded-2xl bg-background-100 border border-background-200 p-4">
                <span className="w-9 h-9 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center">
                  <i className={`${value.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3 text-sm font-bold text-foreground-950">{value.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{value.desc}</p>
              </li>
            ))}
          </ul>

          <Link
            to="/about"
            className="mt-7 inline-flex items-center gap-1.5 text-sm font-bold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            了解爆料91的内容原则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}